import { Data } from 'effect';
import type { AdvancedQuery, DataSource } from 'venn-state';

export type AdvancedQueryRow = Partial<AdvancedQuery> & {
  /** The key is necessary for proper React array rendering */
  key: string | number;
  value?: string | number;
  error?: boolean;
};

export interface LibraryFilterOption<T> {
  label: string;
  value: T;
  subItems?: LibraryFilterOption<T>[];
  /** Icon displayed before the label */
  icon?: JSX.Element;
  /** Badge displayed after the label */
  badge?: JSX.Element;
  /** Whether the option should be hidden or not */
  hidden?: boolean;
  /** Whether the item should be disabled or not */
  disabled?: boolean;
  /** Tooltip to display on hover over the item name */
  tooltip?: string;
  /** custom class */
  className?: string;
  /** Whether the option should only be displayed under advanced filters */
  advancedOnly?: boolean;
}

export interface LibraryFilterSection<T> {
  /** Unique section key, also used for the url param key */
  key: string;
  /** The title of the section */
  title?: string;
  /** The items in the section */
  items: LibraryFilterOption<T>[];
  /** A badge to display next to the section title */
  badge?: JSX.Element;
  /** Whether items in this section are selected through checkboxes or not */
  checkbox?: boolean;
  /** Whether the section should only be displayed under advanced filters */
  advancedOnly?: boolean;
  /** Whether the section should be disabled or not */
  disabled?: boolean;
  /** Tooltip to display on hover over the section name */
  tooltip?: string;
  dataTestId?: string;
}

export type DataSourceFilterEnum = Data.TaggedEnum<{
  Source: { source: DataSource };
  AllIntegrations: {};
  UploadedByMe: {};
  UploadedByTeam: {};
  VennProvided: {};
}>;
export const DataSourceFilterEnum = Data.taggedEnum<DataSourceFilterEnum>();
